export const refineSaleType = (saleType: string) => {
  const peopleDiscountRegex = /^\d+PeopleDiscount$/;
  if (peopleDiscountRegex.test(saleType)) {
    return 'peopleDiscount';
  }
  return saleType;
};
